exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-notification[data-v-e3caa05e]{margin-left:0}.supplier-name[data-v-e3caa05e]{font-weight:700;color:var(--secondary-color)}.supplier-name[data-v-e3caa05e]:hover{cursor:pointer;text-decoration:underline}.title-style[data-v-e3caa05e]{width:200px;-ms-flex-negative:0;flex-shrink:0;color:#000;font-size:18px;font-style:normal;font-weight:600;line-height:24px}", ""]);

// exports
